iScreenWizard.controller(
    "KandidaatController",
    function (
        $scope,
        $state,
        $mdDialog,
        $filter,
        Ajax,
        Dictionary,
        ErrorHandler,
        userService,
        Geslacht,
        Taal,
        Groepscode,
        Testafnamestatus,
        Testafname,
        Rapporttemplate,
        Opleidingsniveau
    ) {
        var pagesize = 20;

        $scope.userService = userService;

        $scope.testafnamestatussen = [];

        $scope.orderBy = "id";
        $scope.desc = true;
        $scope.searchTerm = "";
        $scope.searchGroepscodeId = "0";
        $scope.aanmaakdatum_totenmet = new Date();
        $scope.aanmaakdatum_van = new Date(
            $scope.aanmaakdatum_totenmet.getFullYear() - 1,
            $scope.aanmaakdatum_totenmet.getMonth(),
            $scope.aanmaakdatum_totenmet.getDate()
        );

        $scope.groepscodes = [];
        $scope.groepscodesForSelect = [];
        $scope.testafnames = [];
        $scope.testafnameFilters = {};
        $scope.testafnamePage = 1;
        $scope.testafnameMorePages = true;

        $scope.reportTemplates = [];

        $scope.opleidingsniveaus = [];
        $scope.geslachten = [];
        $scope.talen = [];

        $scope.extraRapportId = 14;
        $scope.addExtraRapport = [155, 158, 159];

        $scope.$on("$stateChangeSuccess", function (event, toState) {
            $scope.refresh();
            $scope.loadTestafnames();

            Testafnamestatus.all().then(function (testafnamestatussen) {
                angular.forEach(
                    testafnamestatussen,
                    function (testafnamestatus) {
                        $scope.testafnamestatussen[testafnamestatus.id] =
                            testafnamestatus;
                    }
                );
            });

            Groepscode.all().then(function (groepscodes) {
                angular.forEach(groepscodes, function (groepscode) {
                    $scope.groepscodes[groepscode.id] = groepscode;
                });
                $scope.groepscodesForSelect = groepscodes;
            });
            Opleidingsniveau.all({ include_non_wizard: 1 }).then(function (
                opleidingsniveaus
            ) {
                angular.forEach(opleidingsniveaus, function (opleidingsniveau) {
                    $scope.opleidingsniveaus[opleidingsniveau.id] =
                        opleidingsniveau;
                });
            });
            Geslacht.all().then(function (geslachten) {
                angular.forEach(geslachten, function (geslacht) {
                    $scope.geslachten[geslacht.id] = geslacht;
                });
            });
            Taal.all().then(function (talen) {
                angular.forEach(talen, function (taal) {
                    $scope.talen[taal.id] = taal;
                });
            });
        });

        $scope.refresh = function () {};

        $scope.loadMoreTestafnames = function () {
            $scope.testafnamePage = $scope.testafnamePage + 1;
            $scope.loadTestafnames();
        };

        $scope.loadTestafnames = function () {
            params = {
                pagesize: pagesize,
                page: $scope.testafnamePage,
                orderby: $scope.orderBy ? $scope.orderBy : "id",
                orderdesc: $scope.desc ? 1 : 0,
                geen_feedbackgevers: 1,
            };
            if ($scope.searchTerm.length > 0) {
                params.searchterm = $scope.searchTerm;
            }
            if ($scope.aanmaakdatum_van) {
                params.aanmaakdatum_van = $filter("date")(
                    new Date($scope.aanmaakdatum_van),
                    "dd-MM-yyyy"
                );
            }
            if ($scope.aanmaakdatum_totenmet) {
                params.aanmaakdatum_totenmet = $filter("date")(
                    new Date($scope.aanmaakdatum_totenmet),
                    "dd-MM-yyyy"
                );
            }
            if ($scope.searchGroepscodeId && $scope.searchGroepscodeId > 0) {
                params.kandidaat_groepscode_id = $scope.searchGroepscodeId;
            }
            Testafname.all(params).then(function (testafnames) {
                angular.forEach(testafnames, function (testafname) {
                    $scope.testafnames.push(testafname);
                    if (testafname.wizardrapporttemplate_id > 0) {
                        if (
                            $scope.reportTemplates[
                                testafname.wizardrapporttemplate_id
                            ]
                        ) {
                            testafname.wizardrapporttemplate =
                                $scope.reportTemplates[
                                    testafname.wizardrapporttemplate_id
                                ];
                        } else {
                            Rapporttemplate.get(
                                testafname.wizardrapporttemplate_id
                            ).then(function (rapporttemplate) {
                                testafname.wizardrapporttemplate =
                                    rapporttemplate;
                                $scope.reportTemplates[rapporttemplate.id] =
                                    rapporttemplate;
                            });
                        }
                        if (
                            $scope.addExtraRapport.indexOf(
                                testafname.wizardrapporttemplate_id
                            ) !== -1
                        ) {
                            Rapporttemplate.get($scope.extraRapportId).then(
                                function (rapporttemplate) {
                                    testafname.wizardextrarapporttemplate =
                                        rapporttemplate;
                                    testafname.wizardextrarapporttemplate_id =
                                        $scope.extraRapportId;
                                }
                            );
                        }
                    }
                });
                if (testafnames.length < pagesize) {
                    $scope.testafnameMorePages = false;
                }
            });
        };

        $scope.sortKandidaten = function (orderBy) {
            if ($scope.orderBy == orderBy) {
                $scope.desc = !$scope.desc;
            } else {
                $scope.desc = false;
            }
            $scope.orderBy = orderBy;

            $scope.testafnames = [];
            $scope.testafnameMorePages = true;
            $scope.testafnamePage = 1;
            $scope.loadTestafnames();
        };

        $scope.searchKandidaten = function () {
            $scope.testafnames = [];
            $scope.testafnameMorePages = true;
            $scope.testafnamePage = 1;
            $scope.loadTestafnames();
        };

        $scope.downloadRapport = function (testafname, ev) {
            selectRapporttemplate(testafname, ev);
        };

        $scope.wijzigKandidaat = function (testafname, geslachten, ev) {
            $mdDialog.show({
                controller: WijzigKandidaatDialogController,
                locals: {
                    testafname: testafname,
                    opleidingsniveaus: $scope.opleidingsniveaus,
                    geslachten: $scope.geslachten,
                    talen: $scope.talen,
                    ev: ev,
                },
                templateUrl: "/kandidaten/wijzig-kandidaat",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            });
        };

        $scope.deleteKandidaat = function (testafname, ev) {
            $scope
                .showKandidaatDeleteDialog(testafname.kandidaat, ev)
                .then(function () {
                    //delete kandidaat if user confirmed
                    Ajax.delete("kandidaat/" + testafname.kandidaat.id).then(
                        function (response) {
                            if (response.data.succes) {
                                var index =
                                    $scope.testafnames.indexOf(testafname);
                                $scope.testafnames.splice(index, 1);
                                $mdDialog.hide();
                            } else {
                                ErrorHandler.showDialog(response);
                            }
                        },
                        function (exception) {
                            //something went wrong
                            ErrorHandler.showDialog(exception);
                        }
                    );
                });
        };

        $scope.showKandidaatDeleteDialog = function (kandidaat, ev) {
            return $mdDialog.show(
                $mdDialog
                    .confirm()
                    .title(Dictionary.translate("app.delete_candidate", true))
                    .htmlContent(
                        Dictionary.translate("app.confirm_delete", true)
                    )
                    .ok(Dictionary.translate("app.okay", true))
                    .cancel(Dictionary.translate("app.cancel", true))
            );
        };

        $scope.opnieuwVersturenRapport = function (testafname, ev) {
            var confirm = $mdDialog
                .confirm()
                .title(Dictionary.translate("app.confirm_resend_report"))
                .targetEvent(ev)
                .ok(Dictionary.translate("app.okay"))
                .cancel(Dictionary.translate("app.cancel"));

            $mdDialog.show(confirm).then(
                function () {
                    Testafname.resendReport(testafname);
                },
                function () {}
            );
        };

        var selectRapporttemplate = function (testafname, ev) {
            $mdDialog.show({
                controller: SelectRapportDialogController,
                locals: {
                    testafname: testafname,
                    ev: ev,
                },
                templateUrl: "/kandidaten/selecteer-rapport",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            });
        };

        var downloadRapportFinal = function (
            testafname,
            ev,
            rapporttemplate_id,
            competentieprofiel_id,
            competentiegroepen
        ) {
            competentieprofiel_id = competentieprofiel_id || null;
            competentiegroepen = competentiegroepen || null;

            $mdDialog.show({
                controller: DownloadRapportDialogController,
                locals: {
                    testafname: testafname,
                    rapporttemplate_id: rapporttemplate_id,
                    competentieprofiel_id: competentieprofiel_id,
                    competentiegroepen: competentiegroepen,
                },
                templateUrl: "/kandidaten/download-rapport",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            });
        };

        function SelectRapportDialogController(
            $scope,
            $mdDialog,
            testafname,
            ev,
            Competentieprofiel,
            Competentiegroep
        ) {
            $scope.testafname = testafname;
            $scope.rapporttemplates = [];
            $scope.loading = true;
            $scope.selectedRapporttemplate = null;
            $scope.selectedCompetentieprofiel = null;
            $scope.selectedCompetentiegroepen = [];
            $scope.COMPETENTIEPROFIELTYPE_THEMA = 1;
            $scope.COMPETENTIEPROFIELTYPE_GENERIEK = 2;
            $scope.COMPETENTIEPROFIELTYPE_GEEN = 3;
            $scope.beschikbareCompetentieprofielen = [];
            $scope.beschikbareCompetentiegroepen = [];

            params = {
                geschikt_voor_testafname_id: testafname.id,
            };

            Rapporttemplate.all(params).then(function (rapporttemplates) {
                $scope.rapporttemplates = rapporttemplates;
                if ($scope.testafname.wizardextrarapporttemplate_id) {
                    $scope.rapporttemplates.unshift(
                        $scope.testafname.wizardextrarapporttemplate
                    );
                }
                angular.forEach(rapporttemplates, function (rapporttemplate) {
                    if (
                        rapporttemplate.id ==
                        $scope.testafname.wizardrapporttemplate_id
                    ) {
                        $scope.selecteerRapporttemplate(rapporttemplate);
                    }
                    if (
                        rapporttemplate.id ==
                        $scope.testafname.wizardextrarapporttemplate_id
                    ) {
                        $scope.selecteerRapporttemplate(rapporttemplate);
                    }
                });
                $scope.loading = false;
            });

            $scope.selecteerRapporttemplate = function (rapporttemplate) {
                $scope.selectedRapporttemplate = rapporttemplate;
                if (
                    rapporttemplate.competentieprofiel_type ==
                        $scope.COMPETENTIEPROFIELTYPE_GENERIEK ||
                    rapporttemplate.competentieprofiel_type ==
                        $scope.COMPETENTIEPROFIELTYPE_THEMA
                ) {
                    $scope.beschikbareCompetentieprofielen = [];
                    params = {
                        testafname_rapporttemplate_id: rapporttemplate.id,
                        testafname_opleidingsniveau_id:
                            testafname.opleidingsniveau_id,
                    };
                    Competentieprofiel.all(params).then(
                        function (competentieprofielen) {
                            //geeft alle beschikbare competentieprofielen terug, voor expert user ook eigen competentieprofielen die voldoen
                            $scope.beschikbareCompetentieprofielen =
                                competentieprofielen;
                            angular.forEach(
                                competentieprofielen,
                                function (competentieprofiel) {
                                    if (
                                        competentieprofiel.id ==
                                        $scope.testafname.competentieprofiel_id
                                    ) {
                                        $scope.selecteerCompetentieprofiel(
                                            competentieprofiel
                                        );
                                    }
                                }
                            );
                            if (
                                $scope.beschikbareCompetentieprofielen.length ==
                                1
                            ) {
                                $scope.selecteerCompetentieprofiel(
                                    $scope.beschikbareCompetentieprofielen[0]
                                );
                            }
                        },
                        function (response) {
                            ErrorHandler.showDialog(response);
                        }
                    );
                }
            };

            $scope.resetCompetentieprofiel = function () {
                $scope.selectedCompetentieprofiel = null;
                $scope.beschikbareCompetentiegroepen = [];
                $scope.selectedCompetentiegroepen = [];
            };

            $scope.selecteerCompetentieprofiel = function (competentieprofiel) {
                $scope.selectedCompetentieprofiel = competentieprofiel;
                $scope.selectedCompetentiegroepen = [];
                if (
                    $scope.selectedRapporttemplate.competentieprofiel_type ==
                    $scope.COMPETENTIEPROFIELTYPE_THEMA
                ) {
                    $scope.beschikbareCompetentiegroepen = [];
                    params = {
                        competentieprofiel_id: competentieprofiel.id,
                    };
                    Competentiegroep.all(params).then(
                        function (competentiegroepen) {
                            $scope.beschikbareCompetentiegroepen =
                                competentiegroepen;
                            angular.forEach(
                                competentiegroepen,
                                function (competentiegroep) {
                                    if (
                                        $scope.testafname.competentiegroep_ids.indexOf(
                                            competentiegroep.id
                                        ) !== -1
                                    ) {
                                        $scope.selectedCompetentiegroepen.push(
                                            competentiegroep
                                        );
                                    }
                                }
                            );
                        },
                        function (response) {
                            ErrorHandler.showDialog(reponse);
                            $scope.resetCompetentieprofiel();
                        }
                    );
                }
            };

            $scope.selectAllCompetentiegroepen = function () {
                $scope.selectedCompetentiegroepen =
                    $scope.beschikbareCompetentiegroepen;
            };

            $scope.canContinue = function () {
                if ($scope.selectedRapporttemplate) {
                    if (
                        $scope.selectedRapporttemplate
                            .competentieprofiel_type ==
                            $scope.COMPETENTIEPROFIELTYPE_GEEN ||
                        $scope.selectedRapporttemplate
                            .competentieprofiel_type === null
                    ) {
                        return true;
                    }
                    if (
                        $scope.selectedRapporttemplate
                            .competentieprofiel_type ==
                        $scope.COMPETENTIEPROFIELTYPE_GENERIEK
                    ) {
                        if ($scope.selectedCompetentieprofiel) {
                            return true;
                        }
                    }
                    if (
                        $scope.selectedRapporttemplate
                            .competentieprofiel_type ==
                        $scope.COMPETENTIEPROFIELTYPE_THEMA
                    ) {
                        if (
                            $scope.selectedCompetentieprofiel &&
                            $scope.selectedCompetentiegroepen &&
                            $scope.selectedCompetentiegroepen.length > 0
                        ) {
                            return true;
                        }
                    }
                }
                return false;
            };

            $scope.downloadRapport = function () {
                if (
                    $scope.selectedRapporttemplate.competentieprofiel_type ==
                        $scope.COMPETENTIEPROFIELTYPE_GEEN ||
                    $scope.selectedRapporttemplate.competentieprofiel_type ===
                        null
                ) {
                    downloadRapportFinal(
                        testafname,
                        ev,
                        $scope.selectedRapporttemplate.id
                    );
                }
                if (
                    $scope.selectedRapporttemplate.competentieprofiel_type ==
                    $scope.COMPETENTIEPROFIELTYPE_GENERIEK
                ) {
                    downloadRapportFinal(
                        testafname,
                        ev,
                        $scope.selectedRapporttemplate.id,
                        $scope.selectedCompetentieprofiel.id
                    );
                }
                if (
                    $scope.selectedRapporttemplate.competentieprofiel_type ==
                    $scope.COMPETENTIEPROFIELTYPE_THEMA
                ) {
                    downloadRapportFinal(
                        testafname,
                        ev,
                        $scope.selectedRapporttemplate.id,
                        $scope.selectedCompetentieprofiel.id,
                        $scope.selectedCompetentiegroepen
                    );
                }
            };
        }

        function DownloadRapportDialogController(
            $scope,
            $mdDialog,
            Ajax,
            testafname,
            rapporttemplate_id,
            competentieprofiel_id,
            competentiegroepen
        ) {
            $scope.testafname = testafname;
            $scope.rapporttemplate_id = rapporttemplate_id
                ? rapporttemplate_id
                : testafname.wizardrapporttemplate_id;
            $scope.stillLoading = true;
            $scope.downLoadUrl = "";
            $scope.mainBlocks = [];
            $scope.mainBlocksEnties = [];

            params = {};
            if (rapporttemplate_id) {
                params.rapporttemplate_id = rapporttemplate_id;
            }
            if (competentieprofiel_id) {
                params.competentieprofiel_id = competentieprofiel_id;
            }
            if (competentiegroepen) {
                params.competentiegroep_ids = [];
                angular.forEach(
                    competentiegroepen,
                    function (competentiegroep) {
                        params.competentiegroep_ids.push(competentiegroep.id);
                    }
                );
            }

            Ajax.get("rapporttemplate/" + $scope.rapporttemplate_id, {
                _method: "get_api_settings",
                testafname_id: testafname.id,
            }).then(function (response) {
                if (response.data.length < 1) {
                    downloadReport(testafname, params);
                } else {
                    $scope.stillLoading = false;
                    $scope.mainBlocks = [];
                    angular.forEach(response.data, function (mainBlock) {
                        $scope.mainBlocks.push(mainBlock);
                    });
                }
            });

            $scope.generate = function () {
                $scope.stillLoading = true;
                angular.extend(params, $scope.mainBlocksEnties);
                downloadReport(testafname, params);
            };

            function downloadReport(testafname, params) {
                Testafname.downloadReport(testafname, params).then(function (
                    response
                ) {
                    $scope.stillLoading = false;
                    if (ErrorHandler.hasErrors(response)) {
                        ErrorHandler.showDialog(response);
                    } else {
                        $scope.mainBlocks = [];
                        $scope.mainBlocksEnties = [];
                        $scope.downLoadUrl =
                            baseUrl +
                            response.data.file_url +
                            "?jwt=" +
                            userService.getToken();
                    }
                });
            }
        }

        function WijzigKandidaatDialogController(
            $scope,
            $mdDialog,
            testafname,
            Kandidaat,
            opleidingsniveaus,
            geslachten,
            talen
        ) {
            $scope.testafname = testafname;
            $scope.opleidingsniveaus = opleidingsniveaus;
            $scope.geslachten = geslachten;
            $scope.talen = talen;

            $scope.saveKandidaatgegevens = function () {
                Kandidaat.update(testafname.kandidaat).then(function (
                    response
                ) {
                    if (ErrorHandler.hasErrors(response)) {
                        ErrorHandler.showDialog(response);
                    } else {
                        $mdDialog.hide();
                    }
                });
            };
        }
    }
);
